export default __webpack_public_path__ + "static/media/misc-closetC-1440w.59fdd3d6.png";